export function openPhonePage () {
  let appId = window.location.hostname.split('.')[0]
  // console.log(appId)
  window.open(` http://${appId}.p.pooway.net.cn/yj_wap/indexSingle`,'_self');
  // window.open(` http://192.168.1.4:8080/yj_wap/indexSingle`,'_self');
  return ''
}
